// const URI = process.env.REACT_APP_API_URI;
const URI = process.env.REACT_APP_API_URI;

const Endpoints = {
  AUTH: {
    LOGOUT: URI + 'logout',
    REFRESH: URI + 'refresh_token',
    LOGIN: URI + 'auth/user/login',
    SIGNUP: URI + 'auth/user/register',
    CHECK: URI + 'auth/user/token/check',
  },
  PRODUCTS: {
    GET_LIST: URI + 'items',
    GET_LIST_BY_BRAND: URI + 'items',
    MAKE_MASTER: URI + 'items/master',
    DEL_MASTER: URI + 'items/master',
    UPDATE_STATUS: URI + 'items/status',
    CHANGE_CATEGORY: URI + 'items/categories/change',
    DO_NOT_MASTER_FLAG: URI + 'items/do-not-master-flag'
  },
  CATEGORIES: {
    GET_BY_ID: URI + 'categories',
    GET_ALL: URI + 'categories/all',
    GET_MASTER_LIST: URI + 'categories/first_level/master',
    GET_ALL_MASTER: URI + 'categories/all/master',
    GET_FIRST_LIST: URI + 'categories/first_level',
    GET_FIRST_SUB_LIST: URI + 'categories',
    GET_ALL_SUB_LIST: URI + 'categories/subcategories/all',
    DELETE: URI + 'categories/local/delete',
    EDIT: URI + 'categories/local/edit',
    CREATE: URI + 'categories/local/create',
    // OLD
    GET_LIST: URI + 'categories/first_level',
    GET_BX_LIST: URI + 'categories/bitrix/first_level',
    GET_BX_SUB_LIST: URI + 'categories/bitrix/first_level',
    COMPARE: URI + 'categories/compare',
    COMPARE_DEL: URI + 'categories/compare',
    GET_WG_LIST: URI + 'categories/first_level', //
    // GET_WG_LIST: URI + 'categories/first_level/master',
    GET_WG_SLAVES_LIST: URI + 'categories',
  },
  STATISTIC: {
    GET_UPDATE_STATUS: URI + 'statistic/apis/update-status',
    GET_GOODS_PRICES: URI + 'goods/prices',
  },
  BRANDS: {
    GET_LIST: URI + 'brands/all',
    GET_COMPARE_LIST: URI + 'brands/compare/auto',
    // GET_WG_LIST_BY_CAT: URI + 'categories/subcategories',
    GET_LIST_BY_CAT: URI + 'categories/subcategories',
  },
  PRICE_SOURCES: {
    GET_LIST: URI + 'admin/price-sources',
    PATCH: URI + 'admin/price-sources',
    CREATE: URI + 'admin/price-sources',
    USE_RRP: URI + 'admin/price-sources/use-rrp',
    USE_RRP_BRANDS: URI + 'admin/price-sources/use-rrp/brands',
  },
  REMAP: {
    DRY_RUN: URI + 'admin/remap-price-source-masters/dry-run',
    APPLY: URI + 'admin/remap-price-source-masters/apply',
    STATUS: URI + 'admin/remap-price-source-masters/status',
  },
  FEEDS: {
    LIST: URI + 'admin/avito-feeds',
    CITIES: URI + 'admin/avito-feeds/cities',
    ONE: URI + 'admin/avito-feeds/',
  },
  CHARACTERISTICS: {
    STATS: URI + 'admin/characteristics/stats',
    CATEGORY: URI + 'admin/characteristics/categories/',
    PRODUCT: URI + 'admin/characteristics/products/',
    DEFINITIONS: URI + 'admin/attribute-definitions',
  },
};

export default Endpoints;
